import React, { Component } from 'react';
import { ArrowUpIcon, ArrowDownIcon } from '../../../../common/icons';

import './HealthsFilterTab.css';

export default class HealthsFilterTab extends Component {
  render() {
    return (
      <div className={`HealthsFilterTab ${this.props.visibleFilters ? 'filtersOpen' : 'filtersClosed'}`}>
        <div className="Tab" onClick={this.props.onTabClick}>
          {this.props.visibleFilters ? <ArrowUpIcon /> : <ArrowDownIcon />}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/HealthsFilterTab/HealthsFilterTab.js